import * as React from 'react';
import {
  Flex,
  Heading,
  Text,
  Button,
  Icon,
  Box,
  useDisclosure,
} from '@chakra-ui/react';
import { getConfig } from '../../config';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

type SectionTextProps = {
  heading: string;
  subHeading: string;
  body: string;
};

const config = getConfig();

export const SectionText: React.FC<SectionTextProps> = ({
  heading,
  subHeading,
  body,
}) => {
  const { onToggle, isOpen } = useDisclosure();
  return (
    <Flex direction="column" p={4} maxW="650px">
      <Flex
        direction="column"
        py={5}
        px={8}
        bgColor="brand.white"
        boxShadow="0px 24px 32px #000F2F14"
        rounded="19px"
      >
        <Heading
          as="h3"
          my={2}
          fontSize="36px"
          color="brand.blue"
          textAlign={{ base: 'center', md: 'left' }}
        >
          {heading}
        </Heading>
        <Text
          fontSize="20px"
          fontWeight="500"
          textAlign={{ base: 'center', md: 'left' }}
        >
          {subHeading}
        </Text>
      </Flex>
      <Flex
        direction="column"
        px={{ base: 2, md: '80px' }}
        py={5}
        align={{ base: 'center', md: 'flex-start' }}
      >
        <Text maxW="440px" pb="40px" textAlign={{ base: 'center', md: 'left' }}>
          {body}
        </Text>
        <Box>
          <Button
            as="a"
            href={`${config.platformUrl}/signup`}
            mr={3}
            fontWeight="400"
            onMouseEnter={onToggle}
            onMouseLeave={onToggle}
          >
            Try for free
          </Button>
          <Icon
            transition="all 0.3s ease"
            ml={isOpen ? '5px' : '0px'}
            verticalAlign="middle"
            color="brand.blue"
            w={10}
            h={10}
            as={HiOutlineArrowNarrowRight}
          />
        </Box>
      </Flex>
    </Flex>
  );
};
